<template>
  <div class="circular-wrapper">
    <div class="circular_progress_bar-container" :style="setCircleColor">
      <div class="percentage">{{ percentage }}%</div>
      <svg class="circular_progress_bar" height="80" width="80">
        <circle :style="setPercentage"
          class="circular_progress_bar__circle"
          stroke-width="8"
          fill="transparent"
          r="32"
          cx="40"
          cy="40"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  name: "CircleProgressBar",
  props: ["percentage", "color"],
  methods: {},
  data() {
    return {}
  },
  computed: {
    setCircleColor() {
      return {
        '--circle-color': this.color
      }
    },
    setPercentage() {
      return {
        '--circle-pct': 201.06192983 - this.percentage / 100 * 201.06192983
      }
    }
  }
};
</script>
<style lang="less">
@import "../../assets/components/common/CircleProgressBar.less";
</style>